import { AlertTriangle } from "lucide-react";

function ExpiredCouponPreview({ previewData }) {
  const formattedDate = new Date(previewData.endDate).toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="relative bg-gradient-to-br from-red-100 via-red-50 to-white border border-red-200 p-8 rounded-3xl shadow-2xl text-center max-w-md w-full">
      <div className="flex flex-col items-center justify-center gap-4">
        <div className="bg-red-100 text-red-600 p-4 rounded-full shadow-inner">
          <AlertTriangle className="w-10 h-10" />
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-red-700 tracking-tight">
          Coupon Expired
        </h2>

        <p className="text-sm text-red-600 max-w-xs">
          This coupon expired on <strong>{formattedDate}</strong>.
        </p>

        <p className="text-sm text-gray-700 max-w-sm">
          Saving this form will <strong>create a new coupon</strong> instead of editing this one.
        </p>
{/* 
        <p className="text-xs text-gray-500 italic">
          No need to manually change the end date — just update and save.
        </p> */}
      </div>
    </div>
  );
}

export default ExpiredCouponPreview;
